<template>
  <info-header-card :icon="submission.icon()" :header="header" :rows="rows" />
</template>

<script>
import InfoHeaderCard from '@/components/shared/InfoHeaderCard'
import ResultModel from '@/models/modus/ResultModel'
import SubmissionModel from '@/models/lab/SubmissionModel'
import moment from 'moment'
import SubmissionExtensionTableDTO from "@/DTO/ExtensionTables/SubmissionExtensionTableDTO"

export default {
  name: 'ResultCard',
  components: {
    InfoHeaderCard
  },
  props: {
    result: {
      type: Object,
      default: () => new ResultModel()
    },
    submission: {
      type: Object,
      default: () => new SubmissionModel()
    }
  },
  data () {
    return {
      card_header: null,
      card_rows: []
    }
  },
  computed: {
    project () {
      return this.submission.project ? this.submission.getProject() : null
    },
    customer () {
      return this.project ? this.project.getCustomer() : null
    },
    header () {
      return `${this.submission.publicNumber()} | ${
        this.customer ? this.customer.full_name : 'Customer not specified'
      }`
    },
    rows () {
      const rows = [
        {
          label: "Identifier",
          value: this.submission.identifier
        },
        {
          label: "Event Code",
          value: this.submission.event_code
        },
        {
          label: 'Created At',
          value: this.result.created_at && moment(this.result.created_at).format("YYYY-MM-DD")
        },
        {
          label: 'Released At',
          value: this.submission.released_at && moment(this.submission.released_at).format("YYYY-MM-DD")
        },
        {
          label: "Test Package",
          value: this.result.test_package && this.result.test_package.name
        },
        {
          label: "Type",
          value: this.submission.sample_type && this.submission.sample_type.name
        }
      ]

      if (this.submission.attribute_1) {
        rows.push(this.setSubmissionExtension('attribute_1'))
      }
      if (this.submission.attribute_2) {
        rows.push(this.setSubmissionExtension('attribute_2'))
      }
      if (this.submission.attribute_3) {
        rows.push(this.setSubmissionExtension('attribute_3'))
      }

      return rows
    }
  },
  methods: {
    setSubmissionExtension(attribute) {
      return {
        label: SubmissionExtensionTableDTO.getHoverTextStatic(this.submission, attribute),
        value: this.submission[attribute],
      }
    }
  }
}
</script>
